import API from './resources'

const actions = {
  async createShorttUrl ({ commit }, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.createAB(data.dados, token)
      commit('SET_CREATE_AB', response)
      return response
    } catch (error) {
      return error
    }
  },
  async splitABLogs ({ commit }, payload) {
    try {
      const response = await API.getSplitAb(
        payload.page,
        payload.size,
        payload.token
      )
      commit('SET_LOGS', response)
      commit('SET_LOGS_PAGINATION', response)

      return response
    } catch (error) {
      return error
    }
  },
  async splitABLogsFilter ({ commit, state }, payload) {
    try {
      const response = await API.getSplitAbFilter(
        state.currentPage,
        payload.size,
        payload.filter,
        payload.token
      )
      commit('SET_LOGS', response)

      return response
    } catch (error) {
      return error
    }
  },
  async editUrls (_, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.putUrlEdition(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async oldLogSplitABLogs ({ commit }, payload) {
    try {
      const response = await API.getOldLogsSplitAb(
        payload.page,
        payload.size,
        payload.token
        )
        commit('SET_LOGS', response)
        commit('SET_LOGS_PAGINATION', response)
      return response
    } catch (error) {
      return error
    }
  },
  async getOldSplitAbFilter ({ commit, state }, payload) {
    try {
      const response = await API.getOldLogsSplitAbFilter(
        state.currentPage,
        payload.size,
        payload.filter,
        payload.token
      )
      commit('SET_LOGS', response)
      return response
    } catch (error) {
      return error
    }
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/splitTest/actions.js